/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import * as actions from './action'
import TableList from './component/tableList'
import {Message, Spin} from 'antd'
import {fetchTableList} from '../../api/clubTable'
import {ClubTableBookSettingProvider} from "./component/bookSettings/store/useClubTableBookSettingContext"

class ClubTableList extends React.Component {
  static defaultProps = {
    clubTable: [],
    timePrice: [],
    tableType: [],
    totalType: [],
    tableInfo: {},
    walletType: [],
    qrcode: {},
  }
  state = {
    loading: true,
    tableList: [],
  }

  componentDidMount() {
    this.props.fetchClubTable().then((res) => {
      this.setState({ loading: false })
    })

    // this.getTableList()
  }

  // 获取桌台列表
  getTableList = async () => {
    const { data, status, detail } = await fetchTableList()
    if (status != 1) {
      Message.error(detail)
      return
    }
    this.setState({
      tableList: data,
      loading: false,
    })
  }

  render() {
    const { clubTable } = this.props
    return (
        <ClubTableBookSettingProvider>
          <div>
            {this.state.loading ? (
                <Spin
                    tip="正在加载..."
                    className="level-loading"
                    style={{ textAlign: 'center' }}
                />
            ) : (
                <TableList
                    list={clubTable}
                    {...this.props}
                    fetchClubTable={this.props.fetchClubTable}
                />
            )}
          </div>
        </ClubTableBookSettingProvider>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    clubTable: state.getClubTable.clubTable,
    timePrice: state.getClubTable.timePrice,
    tableType: state.getClubTable.tableType,
    tableInfo: state.getClubTable.tableInfo,
    walletType: state.getClubTable.walletType,
    qrcode: state.getClubTable.qrcode,
    totalType: state.getClubTable.totalType,
    allPackage: state.getClubTable.allPackage,
    allowPackage: state.getClubTable.allowPackage,
  }
}
export default withRouter(connect(mapStateToProps, actions)(ClubTableList))



// WEBPACK FOOTER //
// ./src/containers/ClubTable/index.js